{
  "certificateAlerting": "HH:mm",
  "filterValidityFormat": "DD/MM/YYYY",
  "date": "DD/MM/YYYY",
  "datetime": "DD/MM/YYYY HH:mm",
  "time": "HH:mm"
}
